import React from 'react'
import type { PresentationBlockProps } from '../../'

export default function Divider(props: PresentationBlockProps) {
  const { WrapperComponent } = props

  return (
    <WrapperComponent {...props}>
      <div>
        <hr />
      </div>
    </WrapperComponent>
  )
}
